export const appConstants = {
  TOKEN_NAME: "keyClockAccessTokenPaymentPanel",
  USER_NAME: "user_login",
  LOGIN_SERVICE: "userservice/api/v1/users/signin",
  REFUND_APPROVED: "paymentservice/api/v1/refund?status=VERIFIED&page=",
  REFUND_INITIATE: "paymentservice/api/v1/refund?status=INITIATE_REFUND&page=",
  REFUND_FAILED: "paymentservice/api/v1/refund?status=REFUND_FAILED&page=",
  REFUND_REQUEST:
    "paymentservice/api/v1/refund?status=PENDING_VERIFICATION&page=",
  REFUND_SUCCESS: "paymentservice/api/v1/refund?status=REFUND_DONE&page=",
  UPDATE_STATUS: "paymentservice/api/v1/refund/update-status",
  FILTER: "paymentservice/api/v1/refund",
  PAYMENT_INITIATE: "paymentservice/api/v1/payment/transactions/",
  PAYMENT_DETAIL: "paymentservice/api/v1/payment/",
  PAYMENT_NRO: "paymentservice/api/v1/refund/create-refund",
  PAYMENT_BLOCKER: "metricsservice/api/v1/payment-methods-blocker",
};
